import React from "react";
import { Box, Chip } from "@mui/material";
import logo from '../../assets/images/stream.png';
import PreviewSurvey from "containers/pages/CANsurvey/PreviewSurvey";

function PreviewSurveyPage() {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "95vh",
        position: "relative",
        px: 0,
        mx: 0,
      }}
    >
      <Box sx={{ flex: 1, width: "100%", height: "100%" }}>
        <PreviewSurvey />
      </Box>

      <Box
        sx={{
          position: "absolute",
          bottom: 8,
          left: "50%",
          transform: "translateX(-50%)",
          zIndex: 1,
          display: { xs: "none", sm: "block" }
        }}
      >
        <Chip
          label="Powered by Stream Data Systems"
          variant="outlined"
          icon={
            <Box
              component="img"
              src={logo}
              alt="logo"
              sx={{ width: 20, height: 20 }}
            />
          }
        />
      </Box>
    </Box>
  );
}

export default PreviewSurveyPage;
